import { useCallback, useEffect } from 'react';

const evtName = 'keydown';

export const useInputHotkeys = ({ current }: RefObject<HTMLInputElement>, onEnter, onEsc): void => {
    const keyPress = useCallback(
        ({ key }: KeyboardEvent) => {
            if (key === 'Escape') {
                onEsc && onEsc();
            } else if (key === 'Enter' || key === 'Tab') {
                onEnter && onEnter();
            }
        },
        [onEnter, onEsc],
    );

    useEffect(() => {
        current && current.addEventListener(evtName, keyPress as any);

        return () => {
            current && current.removeEventListener(evtName, keyPress as any);
        };
    }, [keyPress, current]);
};
